

































































import { computed, defineComponent, ref } from "@vue/composition-api";
import { ContentPriceSubject } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { ContentPriceSubjectTypeEnum } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { EventPostStatus } from "@scrile/api-provider/dist/projects/scrileConnect/EventPostProvider";
import providers from "@/lib/api";
import { formatMoneyString, getCost, getMainCurrencyCode } from "@/lib/moneyHelpers";
import PaymentManager from "@/payments";
import { PurchaseResponse } from "@/payments/types";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import FormatMoney from "@/components/FormatMoney";
import UserSubscribeModal from "../UserSubscribeModal";

export default defineComponent({
  name: "EventTicketPurchaseModal",
  components: { UserSubscribeModal, BaseButton, BaseConfirm, FormatMoney },
  props: {
    show: { type: Boolean, default: false },
    contentFeed: { type: Object as () => ContentFeed },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
  },

  setup(props, { emit }) {
    const purchaseProcessing = ref<boolean>(false);

    const oneTimeCost = computed(() => {
      if (props.contentFeed && props.contentFeed.details.event?.ticketPricePackageId === "0") return 0;
      const paymentPackage = props.paymentPackages.find(
        item => item.id === props.contentFeed?.details.event?.ticketPricePackageId
      );
      if (!paymentPackage) return 0;
      return getCost(paymentPackage);
    });

    const minimumSubscriptionLevelId = computed(() => props.contentFeed?.details.event?.minimumLevelId);

    const isOnlyPrice = computed(
      () =>
        props.contentFeed?.details.event?.minimumLevelId === "0" &&
        props.contentFeed?.details.event?.ticketPricePackageId !== "0"
    );

    const isEventStarted = computed(
      () =>
        props.contentFeed?.details?.event?.status === EventPostStatus.READY_TO_START ||
        props.contentFeed?.details?.event?.status === EventPostStatus.STARTED
    );

    const handleOneTimePurchase = async () => {
      try {
        if (!props.contentFeed) return;
        purchaseProcessing.value = true;
        const data: ContentPriceSubject = {
          subjectId: props.contentFeed.id,
          subjectType: ContentPriceSubjectTypeEnum.EVENT,
        };

        const price = formatMoneyString(oneTimeCost.value, { currencyCode: getMainCurrencyCode() }) || undefined;
        const response: PurchaseResponse = await PaymentManager.purchase({
          pricePackageId: props.contentFeed.details.event?.ticketPricePackageId,
          price,
          subject: {
            subjectId: props.contentFeed.id,
            subjectType: ContentPriceSubjectTypeEnum.EVENT,
          },
        });
        if (response.status && !response.subjectPurchased) {
          await providers.ContentPriceProvider.purchase({ data });
        }
        emit(EVENTS.CONTENT_FEED_PURCHASED, { userId: props.contentFeed.userId, feedId: props.contentFeed.id });
        emit("book");
      } finally {
        purchaseProcessing.value = false;
      }
    };

    return {
      oneTimeCost,
      isOnlyPrice,
      purchaseProcessing,
      minimumSubscriptionLevelId,
      isEventStarted,
      handleOneTimePurchase,
    };
  },
});
